import { useState } from "react";
import { Row, Col, Input, Button, message, Select } from "antd";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { LeftOutlined } from "@ant-design/icons";
// import { REG_PHONE, REG_EMAIL } from '@/common/Utlis'
import { findAccountHttp } from "@/api";

const { Option } = Select;
const ForgetID = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const [type, setType] = useState("1");
  const [email, setemail] = useState("");

  const handleOK = () => {
    if (!email) {
      message.warning(t(63));
      return false;
    }
    findAccountHttp({ type,email }).then((res) => {
      if (res.data.code === 100) {
        message.info(res.data.msg);
      } else {
        message.warning(res.data.msg);
      }
    });
  };
  return (
    <div className="loginBox containerBox">
      <Row className="loginTitle">
        <Col span="12" onClick={() => history.go(-1)}>
          <LeftOutlined /> {t(240)}
        </Col>
        <Col span="12"></Col>
      </Row>
      <Row className="RowBox">
        <Col className="labelTitle" span="4">
          {t(131)}
        </Col>
        <Col span="8">
          <Select
            value={type}
            style={{ width: "100%" }}
            onChange={(value) => setType(value)}
          >
            <Option value="1">{t(28)}</Option>
            <Option value="2">{t(29)}</Option>
          </Select>
        </Col>
        <Col span={12}>
          <Input
            value={email}
            placeholder="Please input your email"
            onChange={(e) => setemail(e.target.value)}
            allowClear
          />
        </Col>
      </Row>
      <Row className="RowBox">
        <Button type="primary" size="large" block onClick={handleOK}>
          {t(239)}
        </Button>
      </Row>
    </div>
  );
};
export default ForgetID;
